import { portalStoreToken } from '@servicetitan/cp-ui';
import { inject, injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable } from 'mobx';
import { WebPortalStore } from '../../common/stores/portal.store';
import { PortalAuthStore } from './portal-auth.store';

@injectable()
export class LogoStore {
    @observable displayImageInHeader: boolean | undefined = undefined;
    @observable naturalWidth: number | undefined = undefined;
    @observable naturalHeight: number | undefined = undefined;
    @observable isLoading: boolean = true;

    constructor(
        @inject(PortalAuthStore) private readonly portalAuthStore: PortalAuthStore,
        @inject(portalStoreToken) private readonly webPortalStore: WebPortalStore
    ) {
        makeObservable(this);
    }

    @action
    setDisplayImageInHeader = (displayInHeader: boolean) => {
        this.displayImageInHeader = displayInHeader;
        this.isLoading = false;
    };

    @action
    setNaturalDimensions = (
        naturalWidth: number | undefined,
        naturalHeight: number | undefined
    ) => {
        this.naturalWidth = naturalWidth;
        this.naturalHeight = naturalHeight;
    };
}
